import { last } from 'lodash';
import { ConsumerExploreDishFirstQuery } from 'src/gqlReactTypings.generated.d';

export const mergePaginatedSegments = (
  queryResults: ConsumerExploreDishFirstQuery | undefined
): ConsumerExploreDishFirstQuery | undefined => {
  if (queryResults?.exploreFoodItems === undefined) {
    return undefined;
  }

  const querySegments = queryResults.exploreFoodItems;
  const segmentsMerged = querySegments.reduce<ConsumerExploreDishFirstQuery['exploreFoodItems']>(
    (mergedSegments, currentSegment) => {
      const previousSegment = last(mergedSegments);
      if (previousSegment?.id !== currentSegment.id) {
        // No merging necessary
        return [...mergedSegments, currentSegment];
      }

      // Merge these two segments' contents
      const newSegmentContentItems = [...previousSegment.content.items, ...currentSegment.content.items];
      const newSegmentContent = { ...previousSegment.content, items: newSegmentContentItems };
      return [
        // Exclude the last item in the previous list, since
        // we want to replace it with the merged version:
        ...mergedSegments.slice(0, mergedSegments.length - 1),
        {
          ...currentSegment,
          content: newSegmentContent,
        },
      ];
    },
    []
  );

  return { ...queryResults, exploreFoodItems: segmentsMerged };
};
